import script from "./LoaderCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderCircle.vue?vue&type=script&setup=true&lang=js"

import "./LoaderCircle.vue?vue&type=style&index=0&id=15892a4a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15892a4a"]])

export default __exports__